import { render, staticRenderFns } from "./BannerSetting.vue?vue&type=template&id=c95497c4&scoped=true&"
import script from "./BannerSetting.vue?vue&type=script&lang=js&"
export * from "./BannerSetting.vue?vue&type=script&lang=js&"
import style0 from "./BannerSetting.vue?vue&type=style&index=0&id=c95497c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95497c4",
  null
  
)

export default component.exports